import * as React from 'react';
import { Switch, UIText2 } from '@cian/ui-kit';

import * as styles from './ServicesLayoutToggle.css';

interface IProps {
  enabled: boolean;
  disabled: boolean;
  withLabel: boolean;
  onChange(v: boolean): void;
}

export const ServicesLayoutToggle = ({ enabled, disabled, withLabel, onChange }: IProps) => (
  <div className={styles['wrapper']}>
    <div className={styles['label']}>{withLabel && <UIText2>{enabled ? 'Включено' : 'Выключено'}</UIText2>}</div>

    <Switch checked={enabled} disabled={disabled} onChange={(_, value) => onChange(value)} />
  </div>
);
